/* global angular */

(function () {
    "use strict";

    var app = angular.module('app');

    app.controller('GlossaryCtrl', ['$scope', '$filter', 'gtm', 'State', 'api', function ($scope, $filter, gtm, State, api) {

        var state = new State();
        var model = {};
        var sources = {};
        var letters = [];

        var publics = {
            state: state,
            model: model,
            sources: sources,
            search: search,
            toggleInitial: toggleInitial,
        };

        angular.extend($scope, publics);

        function setGlossary(data) {
            var index = {}, glossary = [], letters = [];
            angular.forEach(data, function (description, name) {
                var initial = name.substr(0, 1).toUpperCase();
                var name = initial + name.substr(1, name.length - 1).toLowerCase();
                index[initial] = true;
                if (letters.indexOf(initial) === -1) {
                    letters.push(initial);
                }
                if (glossary.length < 100) {
                    glossary.push({
                        initial: initial,
                        name: name,
                        description: description,
                    });
                }
                // console.log('GlossaryCtrl.getGlossary', term);
            });
            // console.log('GlossaryCtrl.getGlossary', glossary[0]);
            sources.letters = letters.sort();
            sources.glossary = glossary.sort(function (a, b) {
                var a = a.name.toUpperCase();
                var b = b.name.toUpperCase();
                return (a < b) ? -1 : (a > b) ? 1 : 0;
            });
        }

        function search() {
            var glossary = sources.glossary;
            if (model.search) {
                var s = model.search.toLowerCase();
                glossary = glossary.filter(function (item) {
                    return (item.name.toLowerCase().indexOf(s) !== -1);
                });
                sources.initial = null;
                // gtm
                gtm.push({
                    event: 'Search',
                    type: 'Glossary',
                    query: model.search
                });
            }
            if (sources.initial) {
                glossary = glossary.filter(function (item) {
                    return item.initial === sources.initial;
                });
            }
            var results = $filter('groupBy')(glossary, 'initial').sort(function (a, b) {
                var a = a.key.toUpperCase();
                var b = b.key.toUpperCase();
                return (a < b) ? -1 : (a > b) ? 1 : 0;
            });
            sources.results = results;
            // console.log('GlossaryCtrl.search', model.search, results.length);
        }

        function Init() {
            if (state.busy()) {
                api.glossary().then(function (response) {
                    setGlossary(response.data);
                    search();
                    // console.log(sources.glossary.length);
                    state.ready();
                }, function (error) {
                    state.error(error);
                });
            }
        }

        function toggleInitial(initial) {
            if (sources.initial === initial) {
                sources.initial = null;
            } else {
                sources.initial = initial;
            }
            search();
        }

        Init();

    }]);

}());